




































import Vue from "vue";
import PlayerCards from "./PlayerCards";
export default PlayerCards;
